import {
  registerLanguage,
  initCulture,
  setCultureOrder,
  setLanguage,
  setLanguageOrder,
} from '@kistler/skybase-ui/skybase-core/locales/actions'

import { getDetectedLanguage } from '@kistler/skybase-ui/skybase-core/locales/utils'
import { batchActions } from 'redux-batched-actions'

// Here is where you link all of the other translations that you will need
// For example: import skybaseAuthTranslations from 'skybase-auth/languages/languages.json'
// eslint-disable-next-line import/extensions
import skybaseUiTranslations from '@kistler/skybase-ui/languages/languages'

// eslint-disable-next-line import/extensions
import localTranslations from '../../languages/languages.json'
import config from '../../config.js'

import '@formatjs/intl-relativetimeformat/polyfill.js'
import '@formatjs/intl-relativetimeformat/locale-data/en.js'
import '@formatjs/intl-relativetimeformat/locale-data/de.js'
import '@formatjs/intl-relativetimeformat/locale-data/es.js'
import '@formatjs/intl-relativetimeformat/locale-data/zh.js'
import '@formatjs/intl-relativetimeformat/locale-data/vi.js'
import '@formatjs/intl-relativetimeformat/locale-data/ko.js'
import '@formatjs/intl-relativetimeformat/locale-data/ru.js'

// @todo Create task for SkyBase (respect `languageOrder` in `initLanguage`).
export const initializeLanguagesAndCulture = dispatch => {
  // Todo:  Fix locales - decouple the locale from the language, etc.
  // Add all locale metadata like number and currency formats, etc.

  const translations = []
  config.languages.forEach(key => {
    translations.push(
      registerLanguage(key, {
        ...skybaseUiTranslations[key],
        ...localTranslations[key],
      }),
    )
  })

  const detectedLanguage = getDetectedLanguage(config.languages)
  dispatch(
    batchActions([
      ...translations,
      setLanguageOrder(config.languages),
      setLanguage(detectedLanguage),
      setCultureOrder(config.cultures),
      initCulture(),
    ]),
  )
}
